module.exports = __webpack_public_path__ + "static/media/02.86554b2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/supplements/02.png
// module id = 643
// module chunks = 0